import { useIsMembershipEligibleUser } from '#src/app/shared/hooks/membership';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

export function useIsEligible(): boolean {
	const isMembershipEligibleUser = useIsMembershipEligibleUser();
	const isMobile = useIsMobile();

	return !isMobile && isMembershipEligibleUser;
}
